import type {ReactElement, ReactNode} from 'react';
// import {useState} from 'react';
import {useEffect} from 'react';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';
import RequestError from '@errors/RequestError';
import {Trans} from '@lingui/macro';
import LoadingDialog from '@components/LoadingDialog/LoadingDialog';
import {activateLocale, chooseOptimalLocale} from '@i18n/i18n';
import ResendCodeBlock from '@components/UserVerificationCode/ResendCodeBlock/ResendCodeBlock';

// import {useLocation} from 'react-router-dom';

interface Props {
    children: ReactNode;
}

export default function PrivateRoute(props: Props): ReactElement<Props> {
    // const location = useLocation();
    // const [isTopupPopupActive, setIsTopupPopupActive] = useState(false);
    const query = useQueryWithAuth({
        queryKey: ['me'],
        queryFn: me,
        refetchOnWindowFocus: true,
    });

    useEffect(() => {
        if (query.isSuccess) {
            activateLocale(chooseOptimalLocale([query.data.data.locale]));

            // if (query.data.data.pagesRemaining < config.topupPopupThreshold) {
            //     console.log('setting topup popup active');
            //     setIsTopupPopupActive(true);
            // }
        }
    }, [query.isSuccess]);

    // for now, I won't ping on every page change, because there are requests on pages that will handle session check
    // but if in future I decide to change that – this is what this code block is about
    // useEffect(() => {
    //     void result.reset();
    // }, [location.pathname]);

    if (
        query.isError &&
        query.error instanceof RequestError &&
        query.error.isUserUnverifiedError()
    ) {
        return (
            <ResendCodeBlock>
                <p>
                    <Trans>
                        User is not verified. Please, check your inbox for the verification email or
                        click the button to receive a new one:
                    </Trans>
                </p>
            </ResendCodeBlock>
        );
    }

    if (
        query.isError &&
        !(query.error instanceof RequestError && query.error.isAuthorizationError())
    ) {
        throw query.error;
    }

    if (query.isLoading) {
        return <LoadingDialog isOpen={query.isLoading} />;
    }

    return <>{props.children}</>;
}
